module.exports = "/assets/images/ee510aad6225f95b98b414a8bc437c2a.png";